import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class TntToolStateService {

    constructor() { }

    private state = new Subject<any>();
    data: any;
    state$ = this.state.asObservable();

    get() { return this.state.next(this.data) }

    set(obj: any = undefined) {
        this.data = obj;
        this.state.next(obj);
    }
}
